import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import { PAYMENT_METHOD } from '../../services/utilityFunctions';
import TenantProp from '../propTypes/tenantProp';
import YourBilling from './YourBilling';
import CountryProp from '../forms/Address/CountryProp';
import UserProp from '../propTypes/userProp';
import AddressProp from '../propTypes/addressProp';
import PaymentByCompany from '../modal/components/PaymentByCompany';
import VatTypesProp from '../forms/Address/VatTypesProp';

export const BILLING_OPTIONS = {
  YOUR_BILLING: 'your_billing',
  COMPANY_BILLING: 'company_billing',
};

const BillingPaymentOptions = props => {
  const {
    t,
    billingAddress,
    handleAddressForm,
    orderAlreadyCreated,
    tenant,
    showAddressForm,
    saveAddress,
    countries,
    user,
    handleAddressChange,
    companyBilling,
    vatTypes,
    billingActive,
    onBillingChange,
    onCompanyBillingChange,
    errors,
    companyEmails,
    onCompanyEmailsChange,
    showPaymentByCompany = true,
    isOnlyPaidByCompany,
    isSubscription,
  } = props;
  const { settings = {} } = tenant;
  const { paymentMethods = [] } = settings;
  const isPaidByCompanyAvailable =
    paymentMethods.includes(PAYMENT_METHOD.PAID_BY_COMPANY) &&
    showPaymentByCompany;

  return (
    <>
      <div className="billing-payment-option row">
        {!isOnlyPaidByCompany && (
          <button
            type="button"
            className={`item ${
              billingActive === BILLING_OPTIONS.YOUR_BILLING && 'active'
            }`}
            onClick={() => onBillingChange(BILLING_OPTIONS.YOUR_BILLING)}
          >
            <img src="/images/shop/yourBilling.svg" alt="your-billing" />
            <p>{t('your.billing.address')}</p>
          </button>
        )}
        {!isSubscription && isPaidByCompanyAvailable && (
          <button
            type="button"
            className={`item ${
              billingActive === BILLING_OPTIONS.COMPANY_BILLING && 'active'
            }`}
            onClick={() => onBillingChange(BILLING_OPTIONS.COMPANY_BILLING)}
          >
            <img src="/images/shop/companyBilling.svg" alt="company-billing" />
            <p>{t('company.billing.address')}</p>
          </button>
        )}
      </div>
      {billingActive === BILLING_OPTIONS.YOUR_BILLING ? (
        <YourBilling
          billingAddress={billingAddress}
          handleAddressForm={handleAddressForm}
          orderAlreadyCreated={orderAlreadyCreated}
          tenant={tenant}
          showAddressForm={showAddressForm}
          saveAddress={saveAddress}
          countries={countries}
          user={user}
          handleAddressChange={handleAddressChange}
          errors={errors}
        />
      ) : (
        showPaymentByCompany && (
          <PaymentByCompany
            countries={countries}
            vatTypes={vatTypes}
            companyBilling={companyBilling}
            onChange={onCompanyBillingChange}
            errors={errors.companyBilling}
            companyEmails={companyEmails}
            onCompanyEmailsChange={onCompanyEmailsChange}
          />
        )
      )}
    </>
  );
};

BillingPaymentOptions.propTypes = {
  t: PropTypes.func.isRequired,
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  saveAddress: PropTypes.func.isRequired,
  showAddressForm: PropTypes.bool.isRequired,
  handleAddressForm: PropTypes.func.isRequired,
  user: PropTypes.shape(UserProp.propType).isRequired,
  handleAddressChange: PropTypes.func.isRequired,
  billingAddress: PropTypes.shape(AddressProp.propType),
  orderAlreadyCreated: PropTypes.string,
  vatTypes: PropTypes.arrayOf(PropTypes.shape(VatTypesProp.propType))
    .isRequired,
  companyBilling: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    taxCode: PropTypes.string,
    taxType: PropTypes.string,
    vatNumber: PropTypes.string,
    address: PropTypes.shape(AddressProp.propType),
  }),
  onBillingChange: PropTypes.func.isRequired,
  onCompanyBillingChange: PropTypes.func.isRequired,
  billingActive: PropTypes.string.isRequired,
  errors: PropTypes.shape({
    billingAddress: PropTypes.arrayOf(PropTypes.shape({})),
    companyBilling: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  onCompanyEmailsChange: PropTypes.func.isRequired,
  companyEmails: PropTypes.shape({
    email: PropTypes.string,
    emails: PropTypes.arrayOf(PropTypes.string),
  }),
  showPaymentByCompany: PropTypes.bool.isRequired,
  isOnlyPaidByCompany: PropTypes.bool,
  isSubscription: PropTypes.bool,
};

BillingPaymentOptions.defaultProps = {
  billingAddress: {},
  orderAlreadyCreated: null,
  companyBilling: {},
  errors: {},
  companyEmails: {
    email: '',
    emails: [],
  },
  isOnlyPaidByCompany: false,
  isSubscription: false,
};

export default translate(BillingPaymentOptions);
